var description_default = {
  "subtitle": "-SI5d",
  "descriptionItem": "PKFzY"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
